import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/* eslint-disable @typescript-eslint/ban-types */
interface ScoreAccordionProps {
  heading: string;
  subheading: string;
  improvement: string;
  bullets: string[];
}
/* eslint-enable @typescript-eslint/ban-types */

const ScoreAccordion: React.FC<ScoreAccordionProps> = ({
  heading,
  subheading,
  bullets,
  improvement,
}) => {
  return (
    <div>
      <Accordion
        style={{
          backgroundColor: "transparent",
          border: "none",
          boxShadow: "none",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#F5F5F5" }} />}
          sx={{ flexDirection: "row-reverse" }}
        >
          <div className="flex flex-col">
            <h6 className="light-text pl-4 font-code text-xl">
              Understanding your <span className="font-bold">{heading}</span>{" "}
              score
            </h6>
            <h6 className="light-text hidden pl-4 font-code text-lg md:block">
              {subheading}
            </h6>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="">
            <h6
              className={`light-text pb-2 pl-4 font-code text-xl ${
                bullets.length === 0 ? "hidden" : ""
              }`}
            >
              <span className="text-orange">To improve your score:</span>{" "}
              <span className="font-bold">{improvement}</span>.
            </h6>
            <h6 className="light-text text-blue pb-2 pl-4 font-code">
              {bullets.length > 0
                ? "The following bullet points can be improved in this area:"
                : "No bullet points identified for improvement."}
            </h6>

            {bullets.length > 0 &&
              bullets.map((bullet, index) => {
                return (
                  <h6 key={index} className="light-text pb-2 pl-4 font-code">
                    - {bullet}
                  </h6>
                );
              })}
          </div>
          <hr className="mx-auto my-4 h-1 w-48 rounded border-0 bg-gray-500" />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ScoreAccordion;
